import { render, staticRenderFns } from "./NewLanding.vue?vue&type=template&id=509cdd8c&scoped=true&"
import script from "./NewLanding.vue?vue&type=script&lang=js&"
export * from "./NewLanding.vue?vue&type=script&lang=js&"
import style0 from "./NewLanding.vue?vue&type=style&index=0&id=509cdd8c&scoped=true&lang=css&"
import style1 from "./NewLanding.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cdd8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
